import { DocumentsSettingsAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import {
  IDeleteDocumentDTO,
  IGetDocumentsDTO,
  TCreateDocumentDTO,
  TGeneralDocumentResponse,
  TGetDocumentsListResponse,
  TUpdateDocumentDTO,
} from '@/models/documentsSettings.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DOC_SETTINGS_SLICE_NAME } from './models';

export const getRequiredDocuments = createAsyncThunk<
  TGetDocumentsListResponse,
  IGetDocumentsDTO,
  { serializedErrorType: IApiError }
>(
  `${DOC_SETTINGS_SLICE_NAME}/getRequiredDocuments`,
  async (data) => {
    const response = await DocumentsSettingsAPI.getDocumentsList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateDocument = createAsyncThunk<
  TGeneralDocumentResponse,
  TUpdateDocumentDTO,
  { serializedErrorType: IApiError }
>(
  `${DOC_SETTINGS_SLICE_NAME}/updateDocument`,
  async (data) => {
    const response = await DocumentsSettingsAPI.updateDocument(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteDocument = createAsyncThunk<
  TGeneralDocumentResponse,
  IDeleteDocumentDTO,
  { serializedErrorType: IApiError }
>(
  `${DOC_SETTINGS_SLICE_NAME}/deleteDocument`,
  async (data) => {
    const response = await DocumentsSettingsAPI.deleteDocument(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createDocument = createAsyncThunk<
  TGeneralDocumentResponse,
  TCreateDocumentDTO,
  { serializedErrorType: IApiError }
>(
  `${DOC_SETTINGS_SLICE_NAME}/createDocument`,
  async ({ createId, ...data }, thunkAPI) => {
    const response = await DocumentsSettingsAPI.createDocument(data);
    return thunkAPI.fulfillWithValue({
      ...response.data,
      createId,
    });
  },
  { serializeError: formatApiError },
);
